export default function ArrowDown() {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.3536 9.35356L13.7678 14.9393C12.7915 15.9157 11.2085 15.9157 10.2322 14.9393L4.64645 9.35356L5.35355 8.64645L10.9393 14.2322C11.5251 14.818 12.4749 14.818 13.0607 14.2322L18.6464 8.64645L19.3536 9.35356Z"
          fill="white"
        />
      </svg>
    </>
  );
}
